import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {LoadingController, ModalController} from "@ionic/angular";
import {AuthService} from "../../../services/auth.service";
import {FormCompleteComponent} from "../form-complete/form-complete.component";
import {Operation} from "../../../models/auth.model";

@Component({
  selector: 'app-form-registration',
  templateUrl: './form-registration.component.html',
  styleUrls: ['./form-registration.component.scss'],
})
export class FormRegistrationComponent implements OnInit {
  form: FormGroup | undefined;
  isSend = false;
  resp: any;
  private loading: any;

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private auth: AuthService
  ) { }

  async ngOnInit() {
    this.loading = await this.loadingCtrl.create({
      message: 'Loading...',
      spinner: 'circles',
    });
    this.form = new FormGroup({
      phone: new FormControl(null, [Validators.required]),
      firstName: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required]),
    });
  }

  modalDismiss() {
    this.modalCtrl.dismiss();
  }

  async send(): Promise<any> {
    this.form?.markAllAsTouched();
    if (this.form?.invalid) { return; }
    this.loading.present().then();
    this.isSend = true;
    this.auth.loginOrRegistrationBySms(Operation.Register, this.form?.get('phone')?.value.replace(/[\s\(\)\-]/g, '')).subscribe(async resp => {
      this.resp = resp;
      if (this.resp?.messages?.length > 0) {
        this.loading.dismiss().then();
        this.isSend = false;
        return;
      }
      const modal = await this.modalCtrl.create({
        component: FormCompleteComponent,
        cssClass: 'login-modal',
        componentProps: {
          'operation': Operation.Register,
          'password': this.form?.get('password')?.value,
          'firstName': this.form?.get('firstName')?.value,
          'lastName': this.form?.get('lastName')?.value,
          'phone': this.form?.get('phone')?.value
        }

      });
      this.loading.dismiss().then();
      modal.present().then();
      this.isSend = false;
      const { data, role } = await modal.onWillDismiss();
      this.onWillDismiss(data, role)
    }, resp => {
      console.error(resp);
    });
  }

  private onWillDismiss(data: any, role: any) {
    this.isSend = false;
  }
}
